// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"222f61e5","197":"46fb2834","672":"28118ca3"}[chunkId] + ".js";
};